import React from "react"
import { useField, Field } from "formik"
import MaskedField from "react-masked-field"
import CurrencyInput from "react-currency-input-field"

const FormikField = ({ ...props }) => {
  const [field, meta, helpers] = useField(props)

  const iosVersion =
    typeof navigator !== "undefined" &&
    navigator &&
    navigator.userAgent &&
    navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/)

  const iosVersionLo13 = iosVersion && parseInt(iosVersion[1]) < 13

  return (
    <>
      {props.type === "radio" ? (
        <div
          className={`custom-control custom-radio ${
            props.noMargin ? "" : "mb-6"
          }`}
          style={props.style}
        >
          <div className="d-flex flex-row">
            {/* <input
            id={props.value}
            {...field}
            {...props}
            className="custom-control-input"
            onBlur={e => helpers.setValue(e.target.value)}
          /> */}
            <Field
              style={{
                marginRight: "8px",
              }}
              id={props.value}
              {...field}
              {...props}
            />
            <label
              htmlFor={props.value}
              className={`fs-16 mb-0 ml-2`}
              style={{ lineHeight: 1 }}
            >
              {props.placeholder}
            </label>
          </div>
          {meta.touched && meta.error && (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {meta.error}
            </div>
          )}
        </div>
      ) : props.type === "checkbox" ? (
        <div className="custom-control custom-checkbox mb-5">
          <div className="d-flex flex-row">
            {/* <input
              style={{
                marginRight: "8px",
              }}
              id={field.name}
              {...field}
              {...props}
            /> */}
            <Field
              style={{
                marginRight: "8px",
              }}
              id={field.name}
              {...field}
              {...props}
            />
            <label
              htmlFor={field.name}
              style={{
                maxWidth: "calc(100% - 26px)",
              }}
            >
              <div
                style={{
                  maxWidth: props.textWith ? `${props.textWith}%` : "90%",
                  marginTop: "-6px",
                  paddingLeft: "5px",
                }}
              >
                {props.placeholder} {field.value}
              </div>
            </label>
          </div>
          {meta.touched && meta.error && (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {meta.error}
            </div>
          )}
        </div>
      ) : props.type === "listselect" ? (
        <div className="form-group mb-5">
          <h4>{props?.placeholder}</h4>
          <ul
            className={`${
              meta.touched && (meta.error ? "is-invalid" : "is-valid")
            } form-control form-control-lg`}
            style={{
              height: "auto",
              borderColor: "transparent",
              listStyle: "none",
              padding: 0,
              margin: 0,
            }}
            {...field}
            {...props}
          >
            {props?.values &&
              props.values.map((value, key) => {
                return (
                  <props.renderComp
                    {...value}
                    key={key}
                    onClick={() => {
                      helpers.setValue(value.id)
                    }}
                  />
                )
              })}
          </ul>
          {meta.touched && meta.error && (
            <div className="invalid-feedback">{meta.error}</div>
          )}
        </div>
      ) : props.type === "select" ? (
        <div className="form-group mb-5">
          <select
            className={`${
              meta.touched && (meta.error ? "is-invalid" : "is-valid")
            } form-control form-control-lg`}
            {...field}
            {...props}
          >
            {props.children}
          </select>
          {meta.touched && meta.error && (
            <div className="invalid-feedback">{meta.error}</div>
          )}
        </div>
      ) : props.type === "ssn" ? (
        <div className="form-group mb-5">
          <MaskedField
            mask="999-99-9999"
            className={`${
              meta.touched && (meta.error ? "is-invalid" : "is-valid")
            } form-control form-control-lg`}
            {...field}
            {...props}
          />
          {meta.touched && meta.error && (
            <div className="invalid-feedback">{meta.error}</div>
          )}
        </div>
      ) : props.type === "dob" ? (
        <div className="form-group mb-5">
          <MaskedField
            mask="99-99-9999"
            className={`${
              meta.touched && (meta.error ? "is-invalid" : "is-valid")
            } form-control form-control-lg`}
            {...field}
            {...props}
          />
          {meta.touched && meta.error && (
            <div className="invalid-feedback">{meta.error}</div>
          )}
        </div>
      ) : props.type === "tel" ? (
        <div className="form-group mb-5">
          <MaskedField
            mask="(999) 999-9999"
            className={`${
              meta.touched && (meta.error ? "is-invalid" : "is-valid")
            } form-control form-control-lg`}
            {...field}
            {...props}
          />
          {meta.touched && meta.error && (
            <div className="invalid-feedback">{meta.error}</div>
          )}
        </div>
      ) : props.type === "currency" ? (
        iosVersionLo13 ? (
          <div className="form-group mb-5">
            {props.prefix && (
              <div className="input-group-prepend">
                <span className="input-group-text">{props.prefix}</span>
              </div>
            )}
            <input
              className={`${
                meta.error && (meta.error ? "is-invalid" : "is-valid")
              } form-control form-control-lg ${props.prefix ? "pl-1" : ""}`}
              {...field}
              {...props}
            />
            {meta.error && <div className="invalid-feedback">{meta.error}</div>}
          </div>
        ) : (
          <div className="form-group mb-5">
            <CurrencyInput
              className={`${
                meta.error && (meta.error ? "is-invalid" : "is-valid")
              } form-control form-control-lg`}
              // {...field}
              {...props}
              value={field.value}
              onValueChange={value => {
                helpers.setTouched()
                helpers.setValue(value)
              }}
            />
            {meta.error && <div className="invalid-feedback">{meta.error}</div>}
          </div>
        )
      ) : (
        <div className="form-group mb-5">
          {props.prefix && (
            <div className="input-group-prepend">
              <span className="input-group-text">{props.prefix}</span>
            </div>
          )}
          <input
            className={`${
              meta.touched && (meta.error ? "is-invalid" : "is-valid")
            } form-control form-control-lg ${props.prefix ? "pl-1" : ""}`}
            {...field}
            {...props}
          />
          {meta.touched && meta.error && (
            <div className="invalid-feedback">{meta.error}</div>
          )}
        </div>
      )}
    </>
  )
}

export default FormikField
